import axios from 'axios';
import { API_URL } from './api';

export const interiorsService = {
    getAll () {
        console.log('interiorsService: getAll');

        return axios
            .get(`${API_URL}/interiors`)
            .then((response) => {
                if (response.data.list)
                {
                    return response.data.list;
                }

                return response;
            });
    },
};

export default interiorsService;
